import React, { useState, useEffect } from 'react';

import { TaskSummaryItem } from '../../tasks/Task.interface';
import { getProductEntityName } from '../../products/Product.config';
import { getOrdinalColorScale } from '@nivo/colors';
import { ResponsiveBar } from '@nivo/bar';
import { DashboardStat } from '../Dashboard.interface';
import styled from 'styled-components';

const StyledDiv = styled.div`
  height: 100%;
`;

export interface DashboardItemGraphProps {
  itemList: TaskSummaryItem[];
}

export const convertToProductEntityName = (workFlowName: string | null) => {
  switch (workFlowName) {
    case 'user-need':
      return getProductEntityName('userNeed');
    case 'design-output':
      return getProductEntityName('designOutput');
    case 'design-input':
      return getProductEntityName('designInput');
    case 'design-verification':
      return getProductEntityName('verification');
    case 'design-validation':
      return getProductEntityName('validation');
    case 'design-spec':
      return getProductEntityName('designSpec');
  }
};

const DashboardItemGraph: React.FC<DashboardItemGraphProps> = (
  props: DashboardItemGraphProps
) => {
  const { itemList } = props;
  const [items, setItems] = useState<DashboardStat[]>([]);
  const isEmpty = items.length === 0 || items.every(item => item.value === 0);

  useEffect(() => {
    if (itemList) {
      const allItems: DashboardStat[] = (itemList || []).map(
        (item: TaskSummaryItem) => {
          return {
            entity: convertToProductEntityName(item.taskTypeName) || 'Unknown',
            value: item.total
          };
        }
      );
      setItems(allItems);
    }
  }, [itemList]);

  return (
    <StyledDiv className={isEmpty ? 'img-empty-container' : undefined}>
      {isEmpty ? (
        <img
          className='img-empty'
          alt='Empty Pending Product Item'
          src='/assets/pending-product-empty-state.png'
        />
      ) : (
        <ResponsiveBar
          data={items}
          keys={['value']}
          indexBy={'entity'}
          margin={{ top: 0, right: 20, bottom: 20, left: 150 }}
          borderRadius={5}
          padding={0.3}
          layout='horizontal'
          axisBottom={{
            format: e => {
              if (Math.floor(parseInt(`${e}`)) !== e) {
                return '';
              }
              return `${e}`;
            }
          }}
          colors={getOrdinalColorScale(
            [
              '#b3b3ff',
              '#d9d9d9',
              '#99ccff',
              '#f47560',
              'rgb(241, 225, 91)',
              '#61cdbb'
            ],
            'index'
          )}
          borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
          axisTop={null}
          axisRight={null}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legendPosition: 'middle',
            legendOffset: -100
          }}
          labelSkipWidth={12}
          labelSkipHeight={12}
          labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
          animate={true}
        />
      )}
    </StyledDiv>
  );
};

export default DashboardItemGraph;
